var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { title: "Import Layers", size: "lg" },
      on: { ok: _vm.handleClose, close: _vm.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _setup.isTemplateDesignsLayersTab
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex w-100 mb-3 flex-column align-items-start",
                    },
                    [
                      _c(_setup.CCheckbox, {
                        attrs: {
                          label: "Keep layer / group ID when importing.",
                          switch: "",
                        },
                        model: {
                          value: _setup.preserveId,
                          callback: function ($$v) {
                            _setup.preserveId = $$v
                          },
                          expression: "preserveId",
                        },
                      }),
                      _vm._v(" "),
                      _c(_setup.CCheckbox, {
                        attrs: {
                          label: "Keep layer group when importing.",
                          switch: "",
                        },
                        model: {
                          value: _setup.preserveGroups,
                          callback: function ($$v) {
                            _setup.preserveGroups = $$v
                          },
                          expression: "preserveGroups",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-cancel",
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _setup.isLayersTab
                    ? _c("div", { staticClass: "d-flex" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-primary",
                            on: { click: _setup.handleBack },
                          },
                          [_vm._v("Back")]
                        ),
                        _vm._v(" "),
                        _setup.parsedFileLayers?.mode !== "PNG"
                          ? _c(
                              "div",
                              { staticClass: "ml-2" },
                              [
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _setup.isLoading,
                                      rounded: "",
                                      opacity: "0.6",
                                      "spinner-small": "",
                                      "spinner-variant": "primary",
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: {
                                          disabled:
                                            !_setup.hasValidSelectedTreeItems ||
                                            _setup.isLoading,
                                        },
                                        on: {
                                          click: _setup.handleImportLayers,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Import\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _setup.isModalOpen,
        callback: function ($$v) {
          _setup.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _setup.showLoader
        ? _c(
            "div",
            {
              staticClass:
                "align-items-center d-flex justify-content-center my-2 text-center my-2",
            },
            [
              _c(_setup.BSpinner, { attrs: { variant: "primary" } }),
              _vm._v(" "),
              _c("strong", { staticClass: "ml-3 primary-text" }, [
                _vm._v(_vm._s(_setup.loaderMessage)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          attrs: { "nav-class": _setup.isLayersTab ? "border-0" : "" },
          model: {
            value: _setup.selectedTab,
            callback: function ($$v) {
              _setup.selectedTab = $$v
            },
            expression: "selectedTab",
          },
        },
        [
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: {
                    title: "Designs",
                    "title-item-class":
                      _setup.isLayersTab ||
                      _setup.selectedTab == _setup.Tabs.Canva
                        ? "hidden"
                        : "",
                  },
                },
                [
                  _c(_setup.ModalImportTabsDesigns, {
                    on: {
                      "design-selected": function ($event) {
                        return _setup.changeTab(_setup.Tabs.DesignsLayers)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: {
                    title: "Designs layers",
                    "title-item-class": "hidden",
                  },
                },
                [
                  _setup.selectedTab === _setup.Tabs.DesignsLayers
                    ? [
                        _setup.template && _setup.selectedItem
                          ? _c(_setup.ModalImportTabsLayers, {
                              attrs: {
                                type: _setup.LayerType.DESIGN,
                                "raw-element": _setup.template,
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: {
                    title: "Templates",
                    "title-item-class":
                      _setup.isLayersTab ||
                      _setup.selectedTab == _setup.Tabs.Canva
                        ? "hidden"
                        : "",
                  },
                },
                [
                  _c(_setup.ModalImportTabsTemplates, {
                    on: {
                      "template-selected": function ($event) {
                        return _setup.changeTab(_setup.Tabs.TemplatesLayers)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: {
                    title: "Template layers",
                    "title-item-class": "hidden",
                  },
                },
                [
                  _setup.selectedTab === _setup.Tabs.TemplatesLayers
                    ? [
                        _setup.template && _setup.selectedItem
                          ? _c(_setup.ModalImportTabsLayers, {
                              attrs: {
                                type: _setup.LayerType.TEMPLATE,
                                "raw-element": _setup.template,
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: {
                    title: "Canva Designs",
                    "title-item-class": "hidden",
                  },
                },
                [
                  _setup.selectedTab === _setup.Tabs.Canva
                    ? [
                        _c(_setup.ModalImportTabsCanva, {
                          on: {
                            "canva-design-selected": function ($event) {
                              return _setup.changeTab(
                                _setup.Tabs.ExternalLayers
                              )
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: { title: "PSD layers", "title-item-class": "hidden" },
                },
                [
                  _setup.selectedTab === _setup.Tabs.ExternalLayers
                    ? [
                        _setup.parsedFileLayers
                          ? _c(_setup.ModalImportTabsExternalLayers, {
                              on: {
                                "fire-import-layers": _setup.handleImportLayers,
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: { title: "Amazon XLSX", "title-item-class": "hidden" },
                },
                [
                  _setup.selectedTab === _setup.Tabs.AmazonFileXLSX
                    ? [
                        _c(_setup.AmazonImportTabsModal, {
                          attrs: { "file-type": "AMAZON_FILE_XLSX" },
                          on: {
                            "fire-import-layers": _setup.handleImportLayers,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.showLoader
            ? _c(
                _setup.BTab,
                {
                  attrs: { title: "Amazon JSON", "title-item-class": "hidden" },
                },
                [
                  _setup.selectedTab === _setup.Tabs.AmazonFileJSON
                    ? [
                        _c(_setup.AmazonImportTabsModal, {
                          attrs: { "file-type": "AMAZON_FILE_JSON" },
                          on: {
                            "fire-import-layers": _setup.handleImportLayers,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }